import React, {useCallback, useEffect, useState} from 'react';
import { css } from "@emotion/core";
import BlockScreen from "./BlockScreen";
import {getPlayer} from "../geo/locator";

let playerWrapper = css`
  position: relative;
  width: 100%;

  iframe {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;

let unauthorized = css`
  height: auto;
  padding-bottom: 0;
  background: url('/content/themes/tpt/dist/images/homepage-hero-backdrop.jpg');
  background-size: cover;

  @media (min-width: 768px) and (min-height: 700px) {
    height: 0;
    padding-bottom: 56.25%;
  }
`;

let blank = css`
  height: auto;
  padding-bottom: 0;
  background: #000;

  @media (min-width: 768px) and (min-height: 700px) {
    height: 0;
    padding-bottom: 56.25%;
  }
`;

export default function Player({ channel, requireDMA = false, onFetched }) {
  let [player, setPlayerData] = useState(null);
  let fetchPlayer = useCallback(() => {
    return getPlayer(channel)
      .then(data => {
        setPlayerData(data);
        return data;
      });
  }, [channel, setPlayerData]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      let cancelled = false;

      fetchPlayer().then(data => {
        if (!cancelled) {
          onFetched(data);
        }
      });

      return () => {
        cancelled = true;
      }
    }
  }, [channel]);

  let authorized = !requireDMA || (player && player.in_dma);

  return <div css={authorized ? playerWrapper : [playerWrapper, unauthorized]}>
    {
      !authorized &&
      player &&
      <BlockScreen user={player} onLocate={fetchPlayer} />
    }
    {
      authorized &&
      player &&
      player.player &&
      <div id="player" dangerouslySetInnerHTML={{ __html: player.player }} />
    }
    {
      authorized &&
      (!player || (player && !player.player)) &&
      <div css={blank} />
    }
  </div>
}